export const primary = '#27383f';
export const white = '#FFFFFF';
export const footer = '#712a51';
export const link = '#ff664b';
export const gray = '#ccc';
